import { EventHandler, useEventListener } from '@bonusly/events';

export const useServerEventListener = (event: string, handler: EventHandler) => {
	return useEventListener(`server:${event}`, handler);
};
